(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('he-connectivity-settings', {
            parent: 'entity',
            params:{screen: 'HEConnectivitySettings'},
            url: '/he-connectivity-settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.heConnectivitySettings.manageHeConnectivitySettings" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/he-connectivity-settings/he-connectivity-settings.html',
                    controller: 'HeConnectivitySettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('heConnectivitySettings');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
        .state('he-connectivity-edit', {
            parent: 'he-connectivity-settings',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/he-connectivity-settings/he-connectivity-settings-dialog.html',
                    controller: 'HeConnectivitySettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['HeConnectivity', 'GlobalValues', function(HeConnectivity, GlobalValues) {
                                     return HeConnectivity.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('he-connectivity-settings-todolist', {
            parent: 'dashboard',
            url: '/heConnectivitySettings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/he-connectivity-settings/he-connectivity-settings-dialog.html',
                    controller: 'HeConnectivitySettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('he-connectivity-settings', null, { reload: 'he-connectivity-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('he-connectivity-settings-todolist-resubmit', {
            parent: 'dashboard',
            url: '/heConnectivitySettingsEdit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/he-connectivity-settings/he-connectivity-settings-dialog.html',
                    controller: 'HeConnectivitySettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('he-connectivity-settings', null, { reload: 'he-connectivity-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
          .state('he-connectiviy-settings-auditLog', {
            parent: 'audit-log',
            url: '/heConnectivitySettingsAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/he-connectivity-settings/he-connectivity-settings-dialog.html',
                    controller: 'HeConnectivitySettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('he-connectivity-settings', null, { reload: 'he-connectivity-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('he-connectiviy-settings-historyReport', {
            parent: 'history-report',
            url: '/heConnectivitySettingsHistory',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/he-connectivity-settings/he-connectivity-settings-dialog.html',
                    controller: 'HeConnectivitySettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('he-connectivity-settings', null, { reload: 'he-connectivity-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         
         };
    })();
